export interface DragAndDropDocument {
  folderName: string;
  subFolderName: string;
  fileName: string;
  container: string;
}
